<template>
  <b-card-code v-if="$checkPermission($options.name, 'view')" id="itf-classificators" no-body>

    <div class="page-header">
      <b-row>
        <b-col v-if="$checkPermission($options.name, 'insert')" lg="2">
          <b-button @click="add" v-b-modal.modal-form variant="primary">Ավելացնել</b-button>
        </b-col>
      </b-row>
    </div>

    <b-table
        striped
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="tableItems"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
    >
      <template #cell(name)="data">
        <span :class="{ 'child-row': data.item.isChild }">
          <span v-if="data.item.isChild" class="child-indent">↳</span>
          {{ data.item.name }}
          <sup v-if="data.item.note">{{ data.item.note }}</sup>
        </span>
      </template>
      <template #cell(nameEn)="data">
        {{ data.item.nameEn }}
        <sup v-if="data.item.note">{{ data.item.note }}</sup>
      </template>
      <template #cell(parentName)="data">
        {{ data.item.parentName || '—' }}
      </template>
      <template #cell(hideForTrailers)="data">
        <b-form-checkbox
          v-if="$checkPermission($options.name, 'update')"
          :checked="!!data.item.hideForTrailers"
          switch
          class="itf-trailer-hide-switch mb-0"
          @change="changeHideForTrailers(data.item, $event)"
        />
        <span v-else>{{ data.item.hideForTrailers ? 'Այո' : 'Ոչ' }}</span>
      </template>
      <template #cell(actions)="data">
        <fa-icon v-if="$checkPermission($options.name, 'update')" @click="changeStatus(data.item)" icon="power-off"
                 :class="'table-action-icon item-status status-' + data.item.status"/>
        <fa-icon v-if="$checkPermission($options.name, 'update')" @click="edit(data.item)" icon="edit" class="table-action-icon accent"/>
        <fa-icon v-if="$checkPermission($options.name, 'delete')" @click="deleteItem(data.item)" icon="trash-alt" class="table-action-icon danger"/>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <b-form-group
          :label="'Գտնվել է ' + totalRows + ' տող'"
          label-cols="3"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      />
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <b-modal
        id="modal-form"
        :no-close-on-backdrop="true"
        cancel-variant="outline-secondary"
        :ok-title="modal_title"
        cancel-title="Կասեցնել"
        centered
        size="md"
        :title="modal_title"
        :is-valid="false"
        @ok="confirmForm"
        :ok-disabled="validateForm"
    >
      <b-form>
        <b-form-group label="Անվանում (HY)">
          <b-form-input
              v-model="form.name"
              type="text"
              placeholder="Անվանում"
          />
        </b-form-group>
        <b-form-group label="Անվանում (EN)">
          <b-form-input
              v-model="form.nameEn"
              type="text"
              placeholder="Name (EN)"
          />
        </b-form-group>
        <b-form-group label="Բաժին">
          <b-form-select
              v-model="form.parent"
              :options="parentOptions"
          />
        </b-form-group>
        <b-form-group label="Նշում (superscript, օր․ 3 կամ 3, 4)">
          <b-form-input
              v-model="form.note"
              type="text"
              placeholder="օր․ 3"
          />
        </b-form-group>
        <b-form-group label="Հերթականություն">
          <b-form-input
              v-model.number="form.ordering"
              type="number"
              placeholder="0"
          />
        </b-form-group>
      </b-form>
    </b-modal>

  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import itfModule from '@/store/itf/itf'
import {
  BButton,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormCheckbox,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import store from '@/store'

export default {
  name: 'itf-classificators',
  components: {
    BCardCode,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BFormInput,
    BButton,
    BCardBody,
    BForm,
    BFormCheckbox,
    BRow,
    BCol,
  },
  data() {
    return {
      ITF_STORE_MODULE_NAME: 'itfModule',
      perPage: 50,
      currentPage: 1,
      sortBy: 'ordering',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      filteredCount: null,
      fields: [
        { key: 'ordering', label: '#', sortable: true },
        { key: 'name', label: 'Անվանում' },
        { key: 'nameEn', label: 'Անվանում (EN)' },
        { key: 'parentName', label: 'Բաժին' },
        { key: 'note', label: 'Նշում' },
        {
          key: 'hideForTrailers',
          label: 'Թաքցնել կցորդներում',
          class: 'text-center',
        },
        {
          key: 'actions',
          label: 'Կարգավիճակ',
          class: 'text-center width-10-per px-0',
        },
      ],
      addForm: false,
      editForm: false,
      formFields: {
        name: '',
        nameEn: '',
        parent: null,
        note: '',
        ordering: 0,
        hideForTrailers: false,
      },
      form: {},
    }
  },
  computed: {
    items() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].classificators || []
    },
    parentMap() {
      const map = {}
      this.items.forEach(item => {
        map[item.id] = item
      })
      return map
    },
    tableItems() {
      const roots = this.items
        .filter(i => !i.parent)
        .slice()
        .sort((a, b) => (a.ordering || 0) - (b.ordering || 0))

      const result = []
      roots.forEach(root => {
        result.push({
          ...root,
          isChild: false,
          parentName: '',
        })
        const children = this.items
          .filter(i => String(i.parent) === String(root.id))
          .slice()
          .sort((a, b) => (a.ordering || 0) - (b.ordering || 0))
        children.forEach(child => {
          result.push({
            ...child,
            isChild: true,
            parentName: root.name,
          })
        })
      })

      // orphans (parent missing)
      const listed = new Set(result.map(i => i.id))
      this.items.forEach(item => {
        if (!listed.has(item.id)) {
          result.push({
            ...item,
            isChild: !!item.parent,
            parentName: (this.parentMap[item.parent] && this.parentMap[item.parent].name) || '—',
          })
        }
      })

      return result
    },
    totalRows() {
      return this.filteredCount != null ? this.filteredCount : this.tableItems.length
    },
    modal_title() {
      return this.addForm ? 'Ավելացնել' : 'Խմբագրել'
    },
    parentOptions() {
      const options = [{ value: null, text: '— Առանց բաժնի (հիմնական) —' }]
      this.items
        .filter(i => !i.parent && (!this.form.id || i.id !== this.form.id))
        .slice()
        .sort((a, b) => (a.ordering || 0) - (b.ordering || 0))
        .forEach(i => {
          options.push({ value: i.id, text: i.name })
        })
      return options
    },
    validateForm() {
      return !this.form.name || !this.form.nameEn
    },
  },
  async created() {
    if (!store.hasModule(this.ITF_STORE_MODULE_NAME)) {
      store.registerModule(this.ITF_STORE_MODULE_NAME, itfModule)
    }
    this.getClassificators()
  },
  methods: {
    getClassificators() {
      this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/getClassificators`)
    },
    onFiltered(filteredItems) {
      this.filteredCount = filteredItems.length
      this.currentPage = 1
    },
    add() {
      this.editForm = false
      this.addForm = true
      this.form = this.$store.getters.getForm(true)(this.formFields)(null)
    },
    edit(item) {
      this.addForm = false
      this.editForm = true
      this.form = this.$store.getters.getForm(false)(this.formFields)(item)
      if (!this.form.parent) this.form.parent = null
      this.$bvModal.show('modal-form')
    },
    deleteItem(item) {
      this.$swal({
        title: 'Հաստատե՞լ գործողությունը',
        text: 'Դուք ցանկանում եք հեռացնել արատորոշումը',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Հաստատել',
        cancelButtonText: 'Մերժել',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/deleteClassificator`, item.id)
            .then(() => {
              this.$swal({
                icon: 'success',
                title: 'Հեռացվել է!',
                text: 'Արատորոշումը հաջողությամբ հեռացվեց',
                customClass: { confirmButton: 'btn btn-success' },
              })
            })
            .catch(error => {
              this.$root.$emit('getError', error)
            })
        }
      })
    },
    changeStatus(item) {
      const status = !item.status
      const action = status ? 'ակտիվացնել' : 'պասիվացնել'
      this.$swal({
        title: 'Հաստատե՞լ գործողությունը',
        text: `Դուք ցանկանում եք ${action} արատորոշումը`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Հաստատել',
        cancelButtonText: 'Մերժել',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/editClassificator`, {
            ...item,
            status,
          })
            .then(() => {
              this.$swal({
                icon: 'success',
                title: '',
                text: 'Փոփոխությունները պահպանվեցին',
                customClass: { confirmButton: 'btn btn-success' },
              })
            })
            .catch(error => {
              this.$root.$emit('getError', error)
            })
        }
      })
    },
    changeHideForTrailers(item, checked) {
      this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/editClassificator`, {
        ...item,
        hideForTrailers: !!checked,
      }).catch(error => {
        this.$root.$emit('getError', error)
      })
    },
    confirmForm() {
      const payload = {
        ...this.form,
        parent: this.form.parent || null,
        note: this.form.note || null,
        ordering: Number(this.form.ordering) || 0,
        hideForTrailers: !!this.form.hideForTrailers,
      }
      const action = this.addForm ? 'addClassificator' : 'editClassificator'
      this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/${action}`, payload)
        .catch(error => {
          this.$root.$emit('getError', error)
        })
    },
  },
}
</script>

<style lang="scss">
#itf-classificators {
  .table-responsive {
    max-height: calc(var(--vh, 1vh) * 100 - 15rem);
    min-height: calc(var(--vh, 1vh) * 100 - 15rem);
  }

  .child-indent {
    margin-right: 0.35rem;
    color: #888;
  }

  .child-row {
    padding-left: 0.5rem;
  }

  .itf-trailer-hide-switch {
    display: inline-flex;
    justify-content: center;
  }

  sup {
    font-size: 0.7em;
  }
}
</style>
